import { render } from "./groups.vue?vue&type=template&id=47ffcf5a&scoped=true"
import script from "./groups.vue?vue&type=script&lang=js"
export * from "./groups.vue?vue&type=script&lang=js"

import "./groups.vue?vue&type=style&index=0&id=47ffcf5a&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ffcf5a"]])

export default __exports__